// MUI Imports
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Divider,
    Grid,
    TextField,
    Typography,
    useTheme
  } from "@mui/material";
  import { useState } from "react";
  
  // Third-Party Imports
  import axios from "axios";
  import { toast, ToastContainer } from "react-toastify";
  import { dev_baseUrl } from "utils/var";
  import { getToken } from "utils/auth";
  
  const UserDeletionPage = () => {
    const theme = useTheme();
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [error, setError] = useState(null);
    const accesstoken = getToken();
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!email) {
        setError("Please enter an email address");
        toast.error("Please enter an email address");
        return;
      }
  
      setIsLoading(true);
      setError(null);
      setApiResponse(null);
  
      try {       

        const response = await fetch(`${dev_baseUrl}/Account/DeleteUser_SuperAdmin?Email=${email}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${accesstoken}`,
              'Content-Type': 'application/json',
            },
          });
  
          const data = await response.json(); 

        if (data.isError) {
          setError(data.message);
          //toast.error(data.message);
        } else {
          setApiResponse(data);
          //toast.success(data.message);
        }
      } catch (err) {
        const errorMsg = err.response?.data?.message || "Failed to delete user. Please try again.";
        setError(errorMsg);
        //toast.error(errorMsg);
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100%',
            width: '100%'
          }}
        >
          <Card sx={{ width: '100%', maxWidth: 800, boxShadow: theme.shadows[4] }}>
            <CardContent sx={{ p: 6 }}>
              <Typography 
                variant="h4" 
                component="h1" 
                sx={{ 
                  mb: 3,
                  textAlign: 'center',
                  fontWeight: 600,
                  color: theme.palette.primary.main
                }}
              >
                User Deletion
              </Typography>
              
              <Typography 
                variant="body1" 
                sx={{ 
                  mb: 4, 
                  textAlign: 'center',
                  color: 'text.secondary'
                }}
              >
                Permanently delete user accounts by email address
              </Typography>
              
              <Divider sx={{ mb: 5 }} />
              
              <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="User Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter user's email address"
                      variant="outlined"
                      error={!!error}
                      helperText={error}
                    />
                  </Grid>
  
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="main"
                      disabled={isLoading}
                      size="large"
                      sx={{
                        py: 2,
                        borderRadius: 1,
                        textTransform: 'none',
                        fontSize: '1rem'
                      }}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                        "Delete User Account"
                      )}
                    </Button>
                  </Grid>
  
                  {apiResponse && (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          p: 3,
                          borderRadius: 1,
                          backgroundColor: theme.palette.success.light,
                          color: theme.palette.success.contrastText
                        }}
                      >
                        <Typography variant="body1" fontWeight={600}>
                          {apiResponse.message}
                        </Typography>
                        {apiResponse.result && (
                          <Typography variant="body2" sx={{ mt: 1.5 }}>
                            {apiResponse.result}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </form>
            </CardContent>
          </Card>
          
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Note: This action cannot be undone. Deleted accounts will be permanently removed.
            </Typography>
          </Box>
        </Box>
        {/*<ToastContainer />*/}
      </Container>
    );
  };
  
  export default UserDeletionPage;